import fetch from '../utils/fetch'

export function getSourcesList (query) {
  return fetch({
    url: '/datacube/sources',
    method: 'get',
    params: query
  })
}

export function getSourcesDetail (sourceId) {
  return fetch({
    url: '/datacube/sources/' + sourceId,
    method: 'get'
  })
}

export function createSources (query) {
  return fetch({
    url: '/datacube/sources',
    method: 'post',
    data: query
  })
}

export function updateSources (sourceId, query) {
  return fetch({
    url: '/datacube/sources/' + sourceId,
    method: 'put',
    data: query
  })
}

export function deleteSources (sourceId) {
  return fetch({
    url: '/datacube/sources/' + sourceId,
    method: 'delete'
  })
}

export function listMonitors (query) {
  return fetch({
    url: '/datacube/monitors',
    method: 'get',
    params: query
  })
}

export function addMonitors (query) {
  return fetch({
    url: '/datacube/monitors',
    method: 'post',
    data: query
  })
}

export function updateMonitors (monitorId, query) {
  return fetch({
    url: '/datacube/monitors/' + monitorId,
    method: 'put',
    data: query
  })
}

export function deleteMonitors (monitorId) {
  return fetch({
    url: '/datacube/monitors/' + monitorId,
    method: 'delete'
  })
}

export function getMonitorsWxaCode64 (query) {
  return fetch({
    url: '/datacube/monitorsWxaCode64',
    method: 'get',
    params: query
  })
}

export function getMonitorsWxaCodeStream (query) {
  return fetch({
    url: '/datacube/monitorsWxaCodeStream',
    method: 'get',
    params: query
  })
}

export function getMonitorsDetail (monitorId) {
  return fetch({
    url: '/datacube/monitors/' + monitorId,
    method: 'get'
  })
}

export function getMonitorsStats (query) {
  return fetch({
    url: '/datacube/monitorsstats',
    method: 'get',
    params: query
  })
}

export function saveSources (query) {
  return fetch({
    url: '/datacube/monitorsRelSources/',
    method: 'post',
    data: query
  })
}

export function getRelSources (monitorId) {
  return fetch({
    url: '/datacube/monitorsRelSources/' + monitorId,
    method: 'get'
  })
}

export function deleteRelSources (monitorId, sourceId) {
  return fetch({
    url: '/datacube/monitorsRelSources/' + monitorId + '/' + sourceId,
    method: 'delete'
  })
}

export function getWxappPages (query) {
  return fetch({
    url: '/datacube/miniprogram/pages',
    method: 'get',
    params: query
  })
}

export function getCompanyData (query) {
  return fetch({
    url: '/datacube/companydata',
    method: 'get',
    params: query
  })
}

export function getFinanceData (query) {
    return fetch({
        url: '/datacube/financedata',
        method: 'get',
        params: query
    })
}

export function getRefundData (query) {
    return fetch({
        url: '/datacube/refunddata',
        method: 'get',
        params: query
    })
}

export function getAftersalesRefundData (query) {
  return fetch({
      url: '/datacube/aftersalesrefunddata',
      method: 'get',
      params: query
  })
}

export function getArtnoData (query) {
    return fetch({
        url: '/datacube/artnodata',
        method: 'get',
        params: query
    })
}

export function getDistributorData (query) {
  return fetch({
    url: '/datacube/distributordata',
    method: 'get',
    params: query
  })
}

export function getGoodsData (query) {
  return fetch({
    url: '/datacube/goodsdata',
    method: 'get',
    params: query
  })
}

export function saveTags(query) {
  return fetch({
    url: '/datacube/savetags',
    method: 'post',
    data: query
  })
}

export function getRealnameData (query) {
    return fetch({
        url: '/datacube/realnamedata',
        method: 'get',
        params: query
    })
}

export function getShopRealnameData (query) {
    return fetch({
        url: '/datacube/shopRealnamedata',
        method: 'get',
        params: query
    })
}

export function getAmountData (query) {
    return fetch({
        url: '/jingzhi/sumAmountlist',
        method: 'get',
        params: query
    })
}

export function getCheckOrderData (query) {
    return fetch({
        url: '/jingzhi/checkOrderlist',
        method: 'get',
        params: query
    })
}

export function distributorDataExport (query) {
  return fetch({
    url: '/datacube/distributordata/exportData',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/datacube.js